import { omit } from "@/lib/utils";
import { TIME_FORMAT_FULL } from "@/schemas/commonFields/time";
import { WriteTimesheetEntry } from "@/types/timesheetEntry";
import { WriteTimesheetEntryContractor } from "../types";
import { normalizeWriteTimesheetEntryDatetimes } from "./normalizeWriteTimesheetEntryDatetimes";

export const convertFormTimesheetEntryContractorsToWriteTimesheetEntry = (
  item: WriteTimesheetEntryContractor,
): WriteTimesheetEntry => {
  // We are omitting the id here because it is UI only id for React.
  // The original_id is the id of the item in the database.
  const { original_id, ...rest } = omit(item, ["id"]);

  // TODO: remove when AR-650 is ready
  // start of temp solution
  const withBreakTime =
    rest.break_time === undefined
      ? {
          ...rest,
          break_time: TIME_FORMAT_FULL,
        }
      : rest;
  // end of temp solution

  const payload =
    original_id === null
      ? withBreakTime
      : {
          ...withBreakTime,
          id: original_id,
        };

  return normalizeWriteTimesheetEntryDatetimes(payload);
};
